<template>
  <div>
    <div class="layout-header" ref="searchBox">
      <div class="infor-layout-header">
        <span class="title">调度信息</span>
      </div>
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        size="small">
        <el-form-item label="品牌名称">
          <el-select v-model="form.brandId" style="width: 150px">
            <el-option label="全部" value="all"></el-option>
            <el-option
              :label="item.value"
              :value="item.key"
              v-for="item in brands"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆编号">
          <el-input v-model="form.bikeId" style="width: 150px"/>
        </el-form-item>
        <el-form-item label="车辆类型">
          <el-select v-model="form.bikeType"  style="width: 150px" :disabled="disabled">
            <el-option
              :label="item.label"
              :value="item.key"
              v-for="item in bikeTypeOptions"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调度状态">
          <el-select v-model="form.bikeStatus" style="width: 150px">
            <el-option
              :label="item.label"
              :value="item.key"
              v-for="item in dispatchStatusOptions"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字段情况">
          <el-input v-model="form.interfaceContent" style="width: 150px"/>
        </el-form-item>
        <el-form-item>
        <el-select v-model="form.timeType" placeholder="请选择时间类型" style="width: 100px;" class="custom-select">
          <el-option label="上架时间" value="1"></el-option>
          <el-option label="下架时间" value="2"></el-option>
        </el-select>
        <el-date-picker
        v-model="form.dataRange"
        style="width: 240px"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd">
        </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
          <el-button v-show="checkUserAuth(4, 217)" @click="onExportBtn">导出</el-button>
          <el-button v-show="checkUserAuth(4, 222)" @click="onDispatchLogExport">导出调度日志</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 10.3125rem"></div>
    <div class="pagination-bg-white layout-header">
      <w-table
        width="100%"
        v-show="checkUserAuth(4, 14)"
        v-loading.body="tableLoading"
        :height="tableViewHeight"
        :data-list="tableData"
        :columns="columns"
        :pageNo="formData.pageNum"
        :pageSize="formData.pageSize"
        :total="total"
        @pageNoChange="pageNoChange"
        @pageSizeChange="handleSizeChange">
        <template v-slot:cell="props">
          <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
          <span v-else-if="props.column.label === '调度状态'">
             {{ props.row["bikeStatus"] | filterBikeStatus }}
          </span>
          <span v-else-if="props.column.label === '下架时间'">
            {{props.row.startTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}
          </span>
          <span v-else-if="props.column.label === '下架站点'">
            <p>{{ props.row["startSiteId"] }}</p>
            <p>{{ props.row["startSiteName"] }}</p>
          </span>
          <span v-else-if="props.column.label === '上架时间'">
            {{props.row.endTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}
          </span>
          <span v-else-if="props.column.label === '上架站点'">
            <p>{{ props.row["endSiteId"] }}</p>
            <p>{{ props.row["endSiteName"] }}</p>
          </span>
          <span v-else-if="props.column.label === '字段情况'">
            <el-tooltip :content="props.row.interfaceContent" placement="top">
              <span>{{ props.row.interfaceContent.slice(0, 10) }}{{ props.row.interfaceContent.length > 10 ? '...' : '' }}</span>
            </el-tooltip>
          </span>
          <span v-else-if="props.column.label === '操作'" @click="getDispatchDetail(props.row)" class="table-btn blue cursor">
            <span>详情</span>
           </span>
          <span v-else>{{ props.row[props.column.property]}}</span>
        </template>
      </w-table>
      <div v-show="!checkUserAuth(4, 216)">您的账户没有权限查看此内容！</div>
    </div>
    <el-dialog title="调度信息明细" :visible.sync="dialogVisible"
               :modal="false"
               :close-on-click-modal="false"
               width="35%">
      <div class="info-line">
        <span class="label">企业名称：</span>
        <span class="value">{{detail.brandOperation}}</span>
      </div>
      <div class="info-line">
        <span class="label">品牌名称：</span>
        <span class="value">{{ detail.brandName }}</span>
      </div>
      <div class="info-line">
        <span class="label">车牌号：</span>
        <span class="value">{{ detail.licenseCode }}</span>
      </div>
      <div class="info-line">
        <span class="label">车辆编号：</span>
        <span class="value">{{ detail.bikeId }}</span>
      </div>
      <div class="info-line">
        <span class="label">车架号：</span>
        <span class="value">{{ detail.frameCode }}</span>
      </div>
      <div class="info-line">
        <span class="label">调度状态：</span>
        <span class="value">{{ detail.bikeStatus | filterBikeStatus }}</span>
      </div>
      <div class="info-line">
        <span class="label">调度开始时间：</span>
        <span class="value">{{ detail.startTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
      </div>
      <div class="info-line">
        <span class="label">调度结束时间：</span>
        <span class="value">{{ detail.endTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
      </div>
      <div class="info-line">
        <span class="label">调度人：</span>
        <span class="value">{{ detail.bikeStatus == 2 ? detail.startByName : detail.endByName }}</span>
      </div>
      <div class="info-line">
        <span class="label">调度人联系电话：</span>
        <span class="value">{{ detail.bikeStatus == 2 ? detail.startPhone : detail.endPhone }}</span>
      </div>
      <div class="info-line">
        <span class="label">调度开始位置：</span>
        <span class="value" style="color: #1ca0ff">
           <template v-if="detail.startSiteName">
            {{ detail.startSiteName }}<br>
          </template>
          <template v-if="detail.startLon && detail.startLat">
            (经度：{{ detail.startLon }},纬度：{{ detail.startLat }})
          </template>
        </span>
      </div>
      <div class="info-line">
        <span class="label">调度结束位置：</span>
        <span class="value" style="color: #1ca0ff">
          <template v-if="detail.endSiteName">
            {{ detail.endSiteName }}<br>
          </template>
          <template v-if="detail.endLon && detail.endLat">
            (经度：{{ detail.endLon }},纬度：{{ detail.endLat }})
          </template>
        </span>
      </div>
      <div class="info-line">
        <span class="label">车辆类型：</span>
        <span class="value">{{ detail.bikeType | filterBikeType }}</span>
      </div>
      <div class="info-line">
        <span class="label">字段情况：</span>
        <span class="value">{{ detail.interfaceContent }}</span>
      </div>
    </el-dialog>
    <!--导出调度接口日志-->
    <w-dialog
      width="60%"
      ref="export-log"
      title="导出设置"
      sureBtnText="导出"
      @handleCloseRight="handleCloseExportLog"
      @handleClose="handleCloseExportLog"
      @onSure="onExportLog">
      <template v-slot:content>
        <el-form ref="form" :model="form" label-width="6.25rem">
          <el-form-item label="品牌选择：">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="checkedBrandIds" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.key" :key="item.key" v-for="item in brands">{{item.value}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="导出时间：">
            <el-select v-model="dataType" size="mini" placeholder="选择类型"
                       class="selectDataType">
              <el-option label="日期" value="day"></el-option>
              <el-option label="月份" value="month"></el-option>
              <el-option label="年份" value="year"></el-option>
            </el-select>
            <el-date-picker
              v-if="dataType === 'day'"
              size="mini"
              v-model="exportTime"
              type="date"
              :clearable="false"
              class="datePickerTime"
              placeholder="选择日期">
            </el-date-picker>
            <el-date-picker
              v-else-if="dataType === 'month'"
              size="mini"
              v-model="exportTime"
              type="month"
              :clearable="false"
              class="datePickerTime"
              placeholder="选择月"
              format="yyyy-MM"/>
            <el-date-picker
              v-else
              size="mini"
              v-model="exportTime"
              type="year"
              :clearable="false"
              class="datePickerTime"
              placeholder="选择年"
              format="yyyy"/>
          </el-form-item>
          <template>
            <el-form-item label="车辆状态：">
              <el-radio-group size="mini" v-model="exportLogAction">
                <el-radio-button label="全部" value="null"></el-radio-button>
                <el-radio-button label="下架" value="2"></el-radio-button>
                <el-radio-button label="上架" value="1"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </template>
        </el-form>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
import WTable from '@/components/Table/index.vue'
import { lookPDF } from '@/utils/tools'
import WDialog from '@/components/Model/index.vue'
export default {
  name: 'dispatchSync',
  components: {
    WDialog,
    WTable
  },
  data() {
    return {
      form: {
        brandId: 'all',
        bikeType: 'all',
        bikeStatus: 'all',
        bikeId: '',
        interfaceContent: '',
        dataRange: [this.dayjs(new Date()).format('YYYY-MM-DD'),
          this.dayjs(new Date()).format('YYYY-MM-DD')],
        timeType: '2'
      },
      bikeTypeOptions: [
        {
          key: 'all',
          label: '全部'
        },
        {
          key: 0,
          label: '自行车'
        }, {
          key: 1,
          label: '电动车'
        }],
      dispatchStatusOptions: [
        {
          key: 'all',
          label: '全部'
        }, {
          key: 1,
          label: '上架'
        }, {
          key: 2,
          label: '下架'
        }],
      tableViewHeight: '',
      columns: [
        {
          prop: 'index',
          label: '序号'
        }, {
          prop: 'brandName',
          label: '品牌名称'
        }, {
          prop: 'bikeId',
          label: '车辆编号'
        }, {
          prop: 'licenseCode',
          label: '车牌号'
        }, {
          prop: 'bikeStatus',
          label: '调度状态'
        }, {
          prop: 'startTime',
          label: '下架时间'
        }, {
          prop: 'startSiteId',
          label: '下架站点',
          width: '120'
        }, {
          prop: 'endTime',
          label: '上架时间'
        }, {
          prop: 'endSiteId',
          label: '上架站点',
          width: '120'
        }, {
          prop: 'interfaceContent',
          label: '字段情况'
        }, {
          fixed: 'right',
          label: '操作'
        }
      ],
      tableLoading: true,
      tableData: [],
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dialogVisible: false,
      detail: {},
      checkedBrandIds: [],
      checkAll: false, // 是否全选
      isIndeterminate: false, // 用以表示 checkbox 的不确定状态，一般用于实现全选的效果
      dataType: 'day',
      exportTime: new Date(),
      exportLogAction: '全部',
      disabled: true
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'brands', 'userBikeType'])
  },
  filters: {
    filterBrandName(value, brands) {
      return brands.some(item => String(item.brandId) === String(value))
        ? brands.find(item => String(item.brandId) === String(value)).brandName
        : undefined
    },
    filterBikeStatus(value) {
      return {
        1: '上架',
        2: '下架'
      }[Number(value)]
    },
    filterBikeType(value) {
      return {
        0: '自行车',
        1: '电动车'
      }[Number(value)]
    }
  },
  created() {
    if (this.userBikeType === 2) {
      this.form.bikeType = 'all'
      this.disabled = false
    } else {
      this.form.bikeType = this.userBikeType
      this.disabled = true
    }
    this.onSearch()
  },
  methods: {
    onSearch() {
      this.tableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        bikeId: this.form.bikeId,
        interfaceContent: this.form.interfaceContent,
        timeType: this.form.timeType
      }
      if (this.form.brandId !== 'all') {
        params.brandId = this.form.brandId
      }
      if (this.form.bikeType !== 'all') {
        params.bikeType = this.form.bikeType
      }
      if (this.form.bikeStatus !== 'all') {
        params.bikeStatus = this.form.bikeStatus
      }
      if (this.form.dataRange) {
        // 获取开始时间和结束时间，并设置时分秒
        params.startTime = this.dayjs(this.form.dataRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.endTime = this.dayjs(this.form.dataRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      Api.getDispatchSyncList(params).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tableData = res.data.lists
          this.total = res.data.total
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.onSearch()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.onSearch()
    },
    getDispatchDetail(row) {
      this.dialogVisible = true
      this.detail = row
    },
    onReset() {
      this.form.brandId = 'all'
      this.form.bikeType = 'all'
      this.form.bikeStatus = 'all'
      this.form.bikeId = ''
      this.form.interfaceContent = ''
      this.form.dataRange = [this.dayjs(new Date()).format('YYYY-MM-DD'),
        this.dayjs(new Date()).format('YYYY-MM-DD')]
      this.form.timeType = '2'
      this.onSearch()
    },
    onExportBtn() {
      if (this.total > 0) {
        this.onSureExport()
      } else {
        this.$confirm('导出数据为空，是否确认导出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.onSureExport()
        }).catch(() => {
          console.log('已取消导出调度列表数据')
        })
      }
    },
    onSureExport() {
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        bikeId: this.form.bikeId,
        interfaceContent: this.form.interfaceContent,
        timeType: this.form.timeType
      }
      if (this.form.brandId !== 'all') {
        params.brandId = this.form.brandId
      }
      if (this.form.bikeType !== 'all') {
        params.bikeType = this.form.bikeType
      }
      if (this.form.bikeStatus !== 'all') {
        params.bikeStatus = this.form.bikeStatus
      }
      if (this.form.dataRange) {
        // 获取开始时间和结束时间，并设置时分秒
        params.startTime = this.dayjs(this.form.dataRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.endTime = this.dayjs(this.form.dataRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      Api.exportDispatchSync(params)
        .then(res => {
          if (res.code === 200) {
            lookPDF(res.data)
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    onDispatchLogExport() {
      this.$refs['export-log'].onShowDialog()
    },
    handleCloseExportLog() {
      this.dataType = 'day'
      this.exportTime = new Date()
      this.checkedBrandIds = []
      this.exportLogAction = '全部'
      this.$refs['export-log'].onCloseDialog()
    },
    onExportLog() {
      if (!this.checkedBrandIds.length) {
        this.$message.warning('请先选择品牌！')
        return
      }
      const params = {
        selfAreaId: this.selfAreaId,
        brandIds: this.checkedBrandIds.join(','),
        action: this.getActionValue(this.exportLogAction),
        year: this.exportTime.getFullYear()
      }
      if (this.dataType === 'day') {
        // getMonth 返回 0-11 所以加 1
        params.month = this.exportTime.getMonth() + 1
        params.day = this.exportTime.getDate()
      }
      if (this.dataType === 'month') {
        params.month = this.exportTime.getMonth() + 1
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.reqLogOutDiaodu(params).then((res) => {
        loading.close()
        this.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        // 处理文件下载
        this.downloadFile(res, '企业调度日志导出.xls')
        this.handleCloseExportLog()
      })
    },
    getActionValue(value) {
      switch (value) {
        case '全部':
          return null
        case '下架':
          return 2
        case '上架':
          return 1
        default:
          return null
      }
    },
    handleCheckAllChange(val) {
      this.checkedBrandIds = val ? this.brands.map(item => item.key) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.brands.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.brands.length
    },
    downloadFile(content, fileName) {
      // 创建Blob对象
      const blob = new Blob([content])
      // 兼容性处理：判断浏览器是否支持 download
      if (this.isDownloadSupported()) {
        // 非IE浏览器
        const elink = document.createElement('a')
        elink.download = fileName
        const url = URL.createObjectURL(blob)
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        // 释放URL对象
        URL.revokeObjectURL(url)
        document.body.removeChild(elink)
      } else if (navigator.msSaveBlob) {
        // IE10及以上浏览器
        navigator.msSaveBlob(blob, fileName)
      } else {
        console.error('当前浏览器不支持文件下载')
      }
    },
    // 判断浏览器是否支持文件下载
    isDownloadSupported() {
      return 'download' in document.createElement('a')
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    }
  }
}
</script>

<style lang="less" scoped>
    .layout-header {
      margin: 16px;
      width: calc(98% - 20px);
    }
    .demo-form-inline{
      margin-top: 24px;
    }
    .info-line {
      display: flex;
      align-items: center; /* 垂直居中 */
      margin-bottom: 15px; /* 每行之间的间距 */
    }
    .label {
      min-width: 120px; /* 根据需要设置标签的最小宽度 */
      text-align: right; /* 标签文本右对齐（但冒号会保持在左边，因为冒号是标签的一部分） */
      padding-right: 15px; /* 标签和值之间的间距 */
      box-sizing: border-box; /* 确保padding不会增加元素的总宽度 */
    }
    .value {
      flex-grow: 1; /* 值占据剩余的空间 */
      word-break: break-all; /* 确保长文本不会溢出容器 */
    }
    ::v-deep .selectDataType {
      .el-input__inner{
        border-right: none !important;
        border-radius: 4px 0 0 4px !important;
        width: 80px;
      }
      .is-focus .el-input__inner {
        border-color: #DCDFE6;
      }
      .el-input__inner:focus {
        border-color: #DCDFE6;
      }
    }
    ::v-deep .datePickerTime .el-input__inner{
      border-radius: 0 4px 4px 0px !important;
      width: 150px !important;
    }
    ::v-deep .custom-select .el-input__inner{
      border: none !important;
    }
</style>
